import React, { useEffect, useState } from "react";
import {
  Button,
  Checkbox,
  Col,
  Divider,
  Form,
  Input,
  notification,
  Row,
  Select,
} from "antd";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Icon } from "@iconify/react";
import Container from "../../style/container";
import AuthWrap from "../../style/auth-wrap";
import { openError, openSuccess } from "../../utils/helper/message";
import AuthLayout from "../../layouts/auth.layout";
import useSignup from "../../hooks/useSignup";

const { Item, useForm } = Form;
const { Option } = Select;

const SignupPage = () => {
  const { signup, loading } = useSignup();

  const navigate = useNavigate();

  const [searchParams] = useSearchParams();

  const redirect = searchParams.get("redirect");

  const [form] = useForm();

  const [api, contextHolder] = notification.useNotification();

  const [checked, setChecked] = useState(false);

  const [short, setShort] = useState("+1");

  const [, forceUpdate] = useState({});

  const onFinish = (values) => {
    signup(
      {
        ...values,
        phone: `${short} ${values.phone}`,
      },
      () => {
        openSuccess(
          api,
          "Signup successful! We've sent you a verification email."
        );
        form.resetFields();
        navigate("/email-verification");
      },
      (err) => {
        openError(api, err.message || "Signup failed.");
      }
    );
  };

  const prefixSelector = (
    <Select
      defaultValue="+1"
      suffixIcon={<Icon icon="mdi:chevron-down" />}
      onChange={(e) => {
        setShort(e);
      }}
      size="large"
    >
      <Option value="+1">+1</Option>
      {/* <Option value="+44">+44</Option> */}
    </Select>
  );

  useEffect(() => {
    forceUpdate({});
  }, []);

  return (
    <Container>
      {contextHolder}
      <Row style={{ justifyContent: "center", alignItems: "center" }}>
        <Col lg={{ span: 8 }} span={AuthLayout}></Col>
        <Col lg={{ span: 8 }} span={AuthLayout}>
          <AuthWrap>
            <Form
              layout="vertical"
              form={form}
              initialValues={{ require: true }}
              onFinish={onFinish}
            >
              <h2>Sign Up</h2>
              <Item
                name="username"
                rules={[
                  {
                    required: true,
                    message: "User name is required",
                  },
                  {
                    min: 7,
                    message: "User name should be at least 7 characters",
                  },
                ]}
              >
                <Input
                  prefix={<span style={{ color: "#aaaaaa" }}>@</span>}
                  size="large"
                  placeholder="Username (no spaces)"
                />
              </Item>
              <Item
                name="firstname"
                rules={[
                  {
                    required: true,
                    message: "First name is required",
                  },
                ]}
                ƒ
              >
                <Input size="large" placeholder="First Name" />
              </Item>
              <Item
                name="lastname"
                rules={[
                  {
                    required: true,
                    message: "Last name is required",
                  },
                ]}
              >
                <Input size="large" placeholder="Last Name" />
              </Item>
              <Item
                name="phone"
                rules={[
                  {
                    required: true,
                    type: "regexp",
                    pattern: new RegExp(/\d+/g),
                    message:
                      "Phone number is required, and it should be number",
                  },
                ]}
              >
                <Input
                  addonBefore={prefixSelector}
                  size="large"
                  placeholder="Phone"
                />
              </Item>
              <Item
                name="email"
                rules={[
                  {
                    required: true,
                    type: "email",
                    message:
                      "Email is required, and it should be an email address",
                  },
                ]}
              >
                <Input size="large" placeholder="Email" />
              </Item>
              <Item
                name="password"
                rules={[
                  {
                    required: true,
                    message: "Password is required",
                  },
                  {
                    pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{6,}$/,
                    message:
                      "Password must be at least 6 characters, include an uppercase, a lowercase, and a number.",
                  },
                ]}
              >
                <Input.Password size="large" placeholder="Password" />
              </Item>
              <Item>
                <Checkbox
                  onChange={(event) => {
                    setChecked(event.target.checked);
                  }}
                >
                  I Agree To Terms & Conditions.
                </Checkbox>
              </Item>

              <Item shouldUpdate>
                {() => (
                  <Button
                    type="primary"
                    size="large"
                    block
                    htmlType="submit"
                    loading={loading}
                    disabled={
                      !form.isFieldsTouched(true) ||
                      !!form
                        .getFieldsError()
                        .filter(({ errors }) => errors.length).length ||
                      !checked
                    }
                  >
                    Sign Up
                  </Button>
                )}
              </Item>
              <Divider>Already have an account?</Divider>
              <Button
                block
                type="link"
                size="large"
                onClick={() => {
                  navigate(
                    redirect ? `/signin/?redirect=${redirect}` : "/signin"
                  );
                }}
              >
                Sign In
              </Button>
            </Form>
          </AuthWrap>
        </Col>
        <Col lg={{ span: 8 }} span={AuthLayout}></Col>
      </Row>
    </Container>
  );
};

export default SignupPage;
